/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '../../common/Checkbox';
import Tooltip from '../../common/tooltip';
import { t } from '../../../modules/infra/i18n';

// Store translation keys instead of calling t() at module level
const SMS_NO_ORIGINATOR_KEY = 'engage:message_types.sms_no_originator';
const STUDIO_OWNER_UPGRADE_KEY = 'engage:message_types.studio_owner_upgrade';

const SelectMessageType = ({
  sendEmailChecked,
  sendSmsChecked,
  sendPushChecked,
  hasSmsOriginator,
  isStudioOwner,
  toggleSendEmail,
  toggleSendSms,
  toggleSendPush,
}) => (
  <div>
    <h2 className="c-heading">
      {t('engage:message_types.select_title')}
    </h2>
    <p className="epsilon u-type--light">
      {t('engage:message_types.how_to_reach')}
    </p>
    <div className="layout layout--small layout--auto u-mt" display-if={isStudioOwner || !hasSmsOriginator}>
      <div className="layout__item">
        <p className="epsilon u-type--light">
          {t('engage:message_types.sms_disabled')}
        </p>
      </div>
      <div className="layout__item">
        <Tooltip
          text={isStudioOwner ? t(STUDIO_OWNER_UPGRADE_KEY) : t(SMS_NO_ORIGINATOR_KEY)}
        />
      </div>
    </div>
    <div className="layout layout--small layout--auto u-mt">
      <div className="layout__item">
        <Checkbox checked={sendEmailChecked} onChange={toggleSendEmail}>
          <span>{t('engage:message_types.email')}</span>
        </Checkbox>
      </div>
      <div className="layout__item" display-if={hasSmsOriginator && !isStudioOwner}>
        <Checkbox checked={sendSmsChecked} onChange={toggleSendSms}>
          <span>{t('engage:message_types.text_message')}</span>
        </Checkbox>
      </div>
      <div className="layout__item">
        <Checkbox checked={sendPushChecked} onChange={toggleSendPush}>
          <span>{t('engage:message_types.push_notification')}</span>
        </Checkbox>
      </div>
    </div>
  </div>
);
SelectMessageType.propTypes = {
  sendEmailChecked: PropTypes.bool,
  sendSmsChecked: PropTypes.bool,
  sendPushChecked: PropTypes.bool,
  hasSmsOriginator: PropTypes.bool,
  isStudioOwner: PropTypes.bool,
  toggleSendEmail: PropTypes.func,
  toggleSendSms: PropTypes.func,
  toggleSendPush: PropTypes.func,
};
SelectMessageType.defaultProps = {
  sendEmailChecked: false,
  sendSmsChecked: false,
  sendPushChecked: false,
  hasSmsOriginator: false,
  isStudioOwner: false,
  toggleSendEmail: () => null,
  toggleSendSms: () => null,
  toggleSendPush: () => null,
};

export default SelectMessageType;
